module.exports = __webpack_public_path__ + "static/scale-model-of-the-dallas-world-aquarium-in-dallas-texas-74149a87b7b6285b4463eb334eb46528.png";